import api from './api';

const alertaService = {
  listarNoLeidas: async () => {
    const { data } = await api.get('/alertas');
    return data.data;
  },

  marcarLeida: async (id) => {
    await api.patch(`/alertas/${id}/leer`);
  },

  marcarTodasLeidas: async () => {
    await api.patch('/alertas/marcar-todas-leidas');
  },
};

export default alertaService;